module.exports = __webpack_public_path__ + "img/legenda.f8866e65.svg";